import React, { useEffect, useState } from "react";
import { Typography, Box, Switch, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Http } from "../../../src/utils";
import {
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
} from "../../model";

interface IPlatform {
  name: string;
  desc: string;
  logo: string;
  id: string;
  txt: string;
}

interface IProps {
  storedDocuments: any;
}

const Platform = ({
  platform,
  handleOpenAuthModal,
  trainingInProgress,
  productParams,
  isDisable,
}: {
  platform: IPlatform;
  handleOpenAuthModal: (name: string) => void;
  trainingInProgress: boolean;
  productParams: any;
  isDisable: boolean;
}) => {
  const [fetchData, setFetchData] = useState<boolean>(false);
  const navigate = useNavigate();
  const { productId, versionId } = useParams();
  const { name, desc, logo, id } = platform;
  const [KBCountValue, setKBCountValue] = useState("");

  const handleFetchArticles = async () => {
    const res: any = await Http.get({
      //url: `/api/v2/kbArticles/${productParams?.products?.[0].id}/${versionId}`,
      url: `/api/v2/kbArticles/${productParams?.products?.[0].id}/${productParams?.products?.[0].version}`,
    });

    if (res?.kbArticles) {
      const kbFolders = res.kbArticles.filter(
        (article: any) => article.type !== "folder" && article.status === "live"
      );
      setKBCountValue(kbFolders.length);
    }
  };

  useEffect(() => {
    if (id == "kb") {
      handleFetchArticles();
    }
  }, [id]);

  const handleChangeSwitch = () => {
    setFetchData((prevState) => !prevState);
  };

  const description = (id: any) => {
    let txt = "";

    if (id == "kb") {
      txt =
        "Setup the Knowledge base with your data to enable AI on your Cuvo products";
    } else if (id == "chat") {
      txt =
        "Setup the chatbot to respond to your customers queries across platform using your knowledge base.";
    } else if (id == "agent") {
      txt = "Setup the feedback agent to meet your consumers where they are.";
    } else if (id == "jira") {
      txt =
        "Jira integration allows you to create tickets on Jira directly from Cuvo";
    } else if (id == "zendesk") {
      txt =
        "Zendesk integration allows you to create tickets on Zendesk directly from Cuvo";
    } else if (id == "email") {
      txt =
        "Setup your email configuration to enable AI assisted replies using Cuvo's email platform";
    } else if (id == "googlereview") {
      txt =
        "Connect Cuvo to your Google play store to analyze your customer's reviews.";
    } else if (id == "autoassign") {
      txt = "Setup Auto assign tickets to CSM for your Cuvo products.";
    } else {
      txt =
        "Connect Cuvo to your Apple App store to analyze your customer's reviews.";
    }
    return txt;
  };

  const cardTopRightText = (id: any) => {
    let txt = "";
    //alert(id)
    if (id == "kb") {
      if (KBCountValue !== "" && parseInt(KBCountValue) > 0) {
        txt = "Live " + KBCountValue;
      } else {
        txt = "Not Configured";
      }
    } else if (
      id == "chat" &&
      productParams?.products?.[0]?.chatAgentSettings &&
      productParams?.products?.[0]?.chatAgentSettings?.aiSetting &&
      productParams?.products?.[0]?.chatAgentSettings?.aiSetting?.openaiKey &&
      productParams?.products?.[0]?.chatAgentSettings?.aiSetting?.openaiKey
        .length > 0
    ) {
      txt = "active";
    } else if (
      id == "agent" &&
      productParams?.products?.[0]?.feedbackAgentSettings &&
      productParams?.products?.[0]?.apiKey
    ) {
      //alert(Object.entries(productParams?.products?.[0]?.feedbackAgentSettings?.feedbackSettings).map(([key, value]) => (" "+key + " - " + value+" ")))
      txt = "active";
    } else if (
      id == "email" &&
      productParams?.products?.[0]?.emailConfig &&
      ((productParams?.products?.[0]?.emailConfig[FEEDBACK_TYPE_BUGS]
        ?.connectionDetails &&
        productParams?.products?.[0]?.emailConfig[FEEDBACK_TYPE_BUGS]
          ?.connectionDetails?.mailServiceAccount) ||
        (productParams?.products?.[0]?.emailConfig[FEEDBACK_TYPE_FEEDBACK]
          ?.connectionDetails &&
          productParams?.products?.[0]?.emailConfig[FEEDBACK_TYPE_FEEDBACK]
            ?.connectionDetails?.mailServiceAccount) ||
        (productParams?.products?.[0]?.emailConfig[FEEDBACK_TYPE_FEATURE_REQ]
          ?.connectionDetails &&
          productParams?.products?.[0]?.emailConfig[FEEDBACK_TYPE_FEATURE_REQ]
            ?.connectionDetails?.mailServiceAccount))
    ) {
      //alert(Object.entries(productParams?.products?.[0].trackingSystem.configs).map(([key, value]) => (" "+key + " - " + value+" ")))
      txt = "Configured";
    } else if (
      id == "autoassign" &&
      productParams?.products?.[0]?.autoAssignConfig &&
      ((productParams?.products?.[0]?.autoAssignConfig[FEEDBACK_TYPE_BUGS]
        ?.isAutoAssign &&
        productParams?.products?.[0]?.autoAssignConfig[FEEDBACK_TYPE_BUGS]
          ?.inputSource?.length > 0) ||
        (productParams?.products?.[0]?.autoAssignConfig[FEEDBACK_TYPE_FEEDBACK]
          ?.isAutoAssign &&
          productParams?.products?.[0]?.autoAssignConfig[FEEDBACK_TYPE_FEEDBACK]
            ?.inputSource?.length > 0) ||
        (productParams?.products?.[0]?.autoAssignConfig[
          FEEDBACK_TYPE_FEATURE_REQ
        ]?.isAutoAssign &&
          productParams?.products?.[0]?.autoAssignConfig[
            FEEDBACK_TYPE_FEATURE_REQ
          ]?.inputSource?.length > 0))
    ) {
      //alert(Object.entries(productParams?.products?.[0].trackingSystem.configs).map(([key, value]) => (" "+key + " - " + value+" ")))
      txt = "Configured";
    } else if (
      id == "zendesk" &&
      productParams?.products?.[0]?.zendeskSettings &&
      ((productParams?.products?.[0]?.zendeskSettings?.configs[
        FEEDBACK_TYPE_BUGS
      ] &&
        productParams?.products?.[0]?.zendeskSettings?.configs[
          FEEDBACK_TYPE_BUGS
        ]?.isToolConnected) ||
        (productParams?.products?.[0]?.zendeskSettings?.configs[
          FEEDBACK_TYPE_FEEDBACK
        ] &&
          productParams?.products?.[0]?.zendeskSettings?.configs[
            FEEDBACK_TYPE_FEEDBACK
          ]?.isToolConnected) ||
        (productParams?.products?.[0]?.zendeskSettings?.configs[
          FEEDBACK_TYPE_BUGS
        ] &&
          productParams?.products?.[0]?.zendeskSettings?.configs[
            FEEDBACK_TYPE_BUGS
          ]?.isToolConnected))
    ) {
      txt = "Configured";
    } else if (
      id == "jira" &&
      productParams?.products?.[0]?.jiraSettings &&
      ((productParams?.products?.[0]?.jiraSettings?.configs[
        FEEDBACK_TYPE_BUGS
      ] &&
        productParams?.products?.[0]?.jiraSettings?.configs[FEEDBACK_TYPE_BUGS]
          ?.isToolConnected) ||
        (productParams?.products?.[0]?.jiraSettings?.configs[
          FEEDBACK_TYPE_FEEDBACK
        ] &&
          productParams?.products?.[0]?.jiraSettings?.configs[
            FEEDBACK_TYPE_FEEDBACK
          ]?.isToolConnected) ||
        (productParams?.products?.[0]?.jiraSettings?.configs[
          FEEDBACK_TYPE_BUGS
        ] &&
          productParams?.products?.[0]?.jiraSettings?.configs[
            FEEDBACK_TYPE_BUGS
          ]?.isToolConnected))
    ) {
      txt = "Configured";
    } else {
      if (id == "kb" || id == "agent" || id == "chat") {
        txt = "inactive";
      } else {
        txt = "Not Configured";
      }

      //alert(Object.entries(productParams?.products?.[0]).map(([key, value]) => (" "+key + " - " + value+" ")))
      //{id == "chat" && productParams?.products?.[0]?.chatAgentSettings && (<Button>rrrr</Button>)}
    }
    return txt;
  };

  const handleRedirectPlayGroundChat = (prodData: any) => {
    const stateObj = {
      playgroundprodData: prodData,
    };
    navigate(`/playground-chat`, { state: stateObj });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      className="platform-card-container"
    >
      <Box
        display="flex"
        justifyContent="end"
        sx={{
          flex: 1,
          backgroundColor: "transparent",
        }}
      ></Box>
      <Box
        display="flex"
        justifyContent="space-between"
        sx={{
          marginBottom: "0px",
          marginTop: "0px",
          marginLeft: "5px",
        }}
      >
        {id !== "kb" && id !== "email" && (
          <img className="imgLogo" src={logo} alt="platform-logo" />
        )}
        {(id === "kb" || id === "email") && (
          <Box
            sx={{
              "& svg": {
                color: "#2858D3",
                fontSize: "2.5rem",
              },
              display: "flex",
              justifyContent: "left",
            }}
          >
            {logo}
          </Box>
        )}

        <button
          className="connectedButton MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium feature-config-btns css-kl9f11-MuiButtonBase-root-MuiButton-root"
          type="button"
        >
          <svg
            className={cardTopRightText(id) + " connectedIcon "}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5788 7.27264L16.1493 6.7478C16.0174 6.33001 15.8498 5.92508 15.6477 5.53774L16.2874 4.15534C16.401 3.91082 16.3495 3.62141 16.1587 3.43087L14.5691 1.84131C14.3783 1.65046 14.0876 1.5993 13.8447 1.71261L12.4623 2.35264C12.0743 2.15018 11.6694 1.98256 11.2525 1.85104L10.7271 0.421247C10.6341 0.168248 10.3931 0 10.1237 0H7.87626C7.60662 0 7.36555 0.168248 7.27264 0.421247L6.7478 1.85104C6.33095 1.98225 5.92603 2.15018 5.53774 2.35264L4.15566 1.71261C3.91051 1.59898 3.62109 1.65046 3.43087 1.84131L1.84131 3.43087C1.65046 3.62141 1.5993 3.91082 1.71261 4.15566L2.35264 5.53774C2.15018 5.92603 1.98225 6.33095 1.85104 6.7478L0.421247 7.27264C0.168248 7.36555 0 7.60662 0 7.87626V10.1237C0 10.3934 0.168248 10.6345 0.421247 10.7274L1.85104 11.2522C1.98225 11.6691 2.15018 12.074 2.35264 12.4623L1.71261 13.8443C1.5993 14.0892 1.65046 14.3786 1.84131 14.5691L3.43087 16.1587C3.62109 16.3492 3.90956 16.4007 4.15566 16.2874L5.53774 15.6474C5.92603 15.8498 6.33095 16.0178 6.7478 16.149L7.27264 17.5788C7.36555 17.8318 7.60662 18 7.87626 18H10.1237C10.3931 18 10.6341 17.8318 10.7271 17.5788L11.2525 16.149C11.6694 16.0174 12.0743 15.8498 12.4623 15.6474L13.8447 16.2874C14.0876 16.4007 14.3783 16.3502 14.5691 16.1587L16.1587 14.5691C16.3495 14.3786 16.401 14.0892 16.2874 13.8447L15.6477 12.4623C15.8498 12.0749 16.0174 11.67 16.1493 11.2522L17.5788 10.7274C17.8318 10.6341 18 10.3934 18 10.1237V7.87626C18 7.60662 17.8318 7.36586 17.5788 7.27264ZM16.7143 9.67487L15.4009 10.1573C15.2044 10.2295 15.055 10.3928 15.001 10.5952C14.8592 11.1285 14.6476 11.6395 14.372 12.1142C14.2665 12.2956 14.2559 12.5169 14.3444 12.7071L14.932 13.9774L13.9777 14.9323L12.7071 14.3441C12.5169 14.2565 12.2965 14.2659 12.1138 14.3717C11.6386 14.6479 11.1282 14.8598 10.5958 15.0007C10.3937 15.0547 10.2298 15.2038 10.1576 15.4006L9.67487 16.7143H8.32513L7.84298 15.4006C7.77047 15.2038 7.60693 15.0547 7.40416 15.0007C6.87305 14.8601 6.36203 14.6482 5.88585 14.3714C5.70442 14.2659 5.48343 14.2552 5.29258 14.3441L4.02257 14.9323L3.0677 13.9774L3.65594 12.7074C3.74414 12.5169 3.7341 12.2956 3.62863 12.1142C3.35177 11.638 3.13989 11.127 2.99927 10.5958C2.94528 10.3931 2.79618 10.2295 2.59937 10.157L1.28571 9.67487V8.32513L2.59937 7.84298C2.79618 7.77047 2.94528 7.60693 2.99927 7.40416C3.13989 6.87305 3.35177 6.36203 3.62863 5.88585C3.7341 5.70442 3.74414 5.48312 3.65594 5.29258L3.0677 4.02257L4.02257 3.0677L5.29258 3.65594C5.48343 3.74477 5.70473 3.7341 5.88585 3.62863C6.36203 3.35177 6.87305 3.13989 7.40416 2.99927C7.60693 2.94528 7.77047 2.79618 7.84298 2.59937L8.32513 1.28571H9.67487L10.1576 2.59937C10.2298 2.79618 10.3937 2.94528 10.5958 2.99927C11.1282 3.14021 11.6386 3.35209 12.1138 3.62831C12.2965 3.73441 12.5181 3.74414 12.7071 3.65594L13.9777 3.0677L14.932 4.02257L14.3444 5.2929C14.2559 5.48312 14.2665 5.70442 14.372 5.88585C14.6476 6.36046 14.8592 6.87148 15.001 7.40479C15.055 7.60725 15.2044 7.77047 15.4009 7.84267L16.7143 8.32513V9.67487Z"
              fill="darkgray"
            />
            <path
              d="M9.00001 4.24701C6.3793 4.24701 4.24701 6.3793 4.24701 9.00001C4.24701 11.6207 6.3793 13.753 9.00001 13.753C11.621 13.753 13.753 11.6207 13.753 9.00001C13.753 6.3793 11.621 4.24701 9.00001 4.24701ZM9.00001 12.4673C7.08807 12.4673 5.53272 10.9119 5.53272 9.00001C5.53272 7.08807 7.08807 5.53272 9.00001 5.53272C10.9116 5.53272 12.4673 7.08807 12.4673 9.00001C12.4673 10.9119 10.9116 12.4673 9.00001 12.4673Z"
              fill="darkgray"
            />
            <path
              d="M10.2317 7.47196L8.53669 9.16479L7.76796 8.39701C7.51622 8.14589 7.10972 8.14589 6.85892 8.39764C6.60812 8.64875 6.60812 9.05587 6.85955 9.30668L8.08248 10.528C8.20804 10.6533 8.37221 10.7161 8.53669 10.7161C8.70117 10.7161 8.86534 10.6533 8.9909 10.528L11.1408 8.38163C11.3919 8.13082 11.3919 7.7237 11.1414 7.47259C10.8903 7.22084 10.4828 7.22147 10.2317 7.47196Z"
              fill="darkgray"
            />
          </svg>

          {<span className={cardTopRightText(id)}>{cardTopRightText(id)}</span>}
        </button>
      </Box>
      <Box
        display="flex"
        justifyContent="left"
        alignItems="left"
        sx={{
          height: "28px",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            marginLeft: "5px",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          {name}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="left"
        alignItems="left"
        sx={{
          height: "40px",
          marginLeft: "5px",
          marginTop: "7px",
          width: "96%",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            textAlign: "left",
            color: "#8d919f",
            fontWeight: 400,
          }}
        >
          {description(id)}

          {/* {Object.entries(platform).map(([key, value]) => (key + " - " + value))} */}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="left"
        flexDirection="column"
        alignItems="left"
        sx={{
          marginTop: "30px",
        }}
      >
        {trainingInProgress && id === "kb" ? (
          <Button
            variant="text"
            disabled
            onClick={() => handleOpenAuthModal(id)}
          >
            Training In Progress
          </Button>
        ) : (
          <Box
            display="flex"
            flexDirection="row"
            className="feature-config-btn-parent"
          >
            <Button
              className="feature-config-btns"
              variant="text"
              onClick={() => handleOpenAuthModal(id)}
              sx={{
                fontSize: "12px",
                backgroundColor: "transparent",
              }}
              disabled={isDisable}
            >
              Configure
            </Button>

            <Button
              className="feature-config-btns"
              variant="text"
              onClick={() => handleOpenAuthModal(id)}
              sx={{
                fontSize: "12px",
                backgroundColor: "whitesmoke",
                justifyContent: "right",
                alignItems: "right",
                margin: "0px 0",
                marginLeft: "150px",
                borderRadius: "4px",
                display: "none",
              }}
              disabled={isDisable}
            >
              Integrate
            </Button>
            {id == "chat" &&
              productParams?.products?.[0]?.chatAgentSettings?.aiSetting &&
              productParams?.products?.[0]?.chatAgentSettings?.aiSetting
                ?.openaiKey &&
              productParams?.products?.[0]?.chatAgentSettings?.aiSetting
                ?.openaiKey.length > 0 && (
                <Button
                  className="feature-config-btns"
                  onClick={() => handleRedirectPlayGroundChat(productParams)}
                  variant="text"
                  sx={{
                    fontSize: "12px",
                    backgroundColor: "transparent",
                  }}
                  disabled={isDisable}
                >
                  PLAYGROUND
                </Button>
              )}
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default Platform;
